// extracted by mini-css-extract-plugin
export default {"title":"ExampleForWebsite_title__GCq+x","cards":"ExampleForWebsite_cards__3eAOx","card":"ExampleForWebsite_card__I1KFZ"};